export const groupSchools = [
  {
    id: 1,
    name: "中央情報大学校",
    url: "https://www.chuo.ac.jp/cid/",
    courses: ["情報", "デザイン", "電気通信", "ゲーム", "アグリ・フードテック", "留学生"],
    description:
      "情報技術・デザイン・ゲーム・アグリテック分野の専門人材を育成する大学校です。実践的なカリキュラムと充実した実習環境で、IT業界やクリエイティブ業界で活躍できる即戦力を養成しています。",
  },
  {
    id: 2,
    name: "中央農業大学校",
    url: "https://www.chuo.ac.jp/cag/",
    courses: ["スマート農業", "有機栽培", "カフェ&ハーブ", "ビューティ&フード"],
    description:
      "スマート農業や有機栽培など、次世代の農業を担う人材を育成する大学校です。実習を重視したカリキュラムで、地域農業の発展を支えるプロフェッショナルを育てています。",
  },
  {
    id: 3,
    name: "中央情報経理専門学校",
    url: "https://www.chuo.ac.jp/cia/",
    courses: ["会計・経理", "ビジネス", "医療事務", "医薬販売", "保育・福祉", "留学生"],
    description:
      "会計・経理、ビジネス、医療事務、保育・福祉など、幅広い分野で社会に貢献する人材を育成する専門学校です。資格取得と就職支援に力を入れています。",
  },
  {
    id: 4,
    name: "群馬法科ビジネス専門学校",
    url: "https://www.chuo.ac.jp/glc/",
    courses: ["国家公務員", "地方公務員", "消防士", "警察官"],
    description:
      "国家公務員・地方公務員・消防士・警察官など、公務員試験合格を目指す学生を徹底サポートする専門学校です。少人数制のきめ細かな指導で高い合格実績を誇ります。",
  },
  {
    id: 5,
    name: "高崎ビューティモード専門学校",
    url: "https://www.chuo.ac.jp/tbm/",
    courses: ["美容", "理容", "トータルビューティ", "ブライダル"],
    description:
      "美容・理容・ブライダル分野のプロフェッショナルを育成する専門学校です。株式会社TBM健康美容研究所のパートナー校として、最新の美容理論と実践的な技術教育を提供しています。",
  },
  {
    id: 6,
    name: "中央医療歯科専門学校 太田校",
    url: "https://www.chuo.ac.jp/cis/",
    courses: ["歯科衛生士"],
    description:
      "歯科衛生士の国家資格取得を目指す専門学校です。医療現場で求められる実践的なスキルと知識を、充実した実習設備で身につけることができます。",
  },
  {
    id: 7,
    name: "中央医療歯科専門学校 高崎校",
    url: "https://www.chuo.ac.jp/cis/",
    courses: ["歯科衛生士"],
    description:
      "歯科衛生士の国家資格取得を目指す専門学校です。経験豊富な講師陣による丁寧な指導で、確かな技術と知識を習得できます。",
  },
  {
    id: 8,
    name: "中央動物看護専門学校",
    url: "https://www.chuo.ac.jp/can/",
    courses: ["動物看護学科", "動物飼育学科", "動物美容学科"],
    description:
      "動物看護・動物飼育・動物美容など、動物と人をつなぐ専門人材を育成する専門学校です。動物との実践的な関わりを通じて、即戦力となるスキルを養成します。",
  },
  {
    id: 9,
    name: "中央スポーツ医療専門学校",
    url: "https://www.chuo.ac.jp/csm/",
    courses: ["柔道整復師"],
    description:
      "柔道整復師の国家資格取得を目指す専門学校です。スポーツ医療の分野で活躍できる人材を育成し、アスリートのケアと地域医療に貢献しています。",
  },
  {
    id: 10,
    name: "中央高等専修学校",
    url: "https://www.chuo.ac.jp/chs/",
    courses: ["高等専修学校卒業資格", "高等学校卒業資格"],
    description:
      "高等学校卒業資格と専門的な職業スキルを同時に取得できる高等専修学校です。学びと実践を両立したカリキュラムで、卒業後の進路を幅広くサポートします。",
  },
];

export const groupCompanies = [
  {
    id: 1,
    name: "株式会社CRI中央総研",
    url: "http://gcri.co.jp/",
    tagline: "シンクタンク&ビジネスコンサルティング",
    description:
      "シンクタンクとして、企業・自治体向けの調査研究やビジネスコンサルティングを提供しています。データに基づく分析で、経営課題の解決を支援します。",
  },
  {
    id: 2,
    name: "中央レコードマネジメント株式会社",
    url: "https://www.g-rm.co.jp/",
    tagline: "記録情報管理の総合パートナー",
    description:
      "文書・記録情報の管理サービスを提供する総合パートナーです。企業の情報資産を安全かつ効率的に管理し、業務の生産性向上をサポートします。",
  },
  {
    id: 3,
    name: "日本パスコム株式会社",
    url: "http://www.pascom.co.jp/",
    tagline: "トータルネットワークソリューション",
    description:
      "ネットワーク構築からITソリューションの提供まで、企業の情報通信基盤をトータルに支援する企業です。安定した通信環境の構築を実現します。",
  },
  {
    id: 4,
    name: "中央キャリアネット株式会社",
    url: "https://www.c-c-nt.com/",
    tagline: "少しむずかしい・しかし欲しい人材を探す会社",
    description:
      "専門性の高い人材の紹介・派遣サービスを提供しています。企業が本当に求める人材を的確にマッチングし、採用課題の解決を支援します。",
  },
  {
    id: 5,
    name: "中央総合教育サービス株式会社",
    url: "https://www.chuo-sogo.com/",
    tagline: "職業教育の専門機関",
    description:
      "職業教育に特化した専門機関として、実践的な教育サービスを提供しています。社会で活躍できる人材の育成をトータルでサポートします。",
  },
  {
    id: 6,
    name: "中央フレッシュフーズ株式会社",
    url: "https://chuo-fd.jp/",
    tagline: "食品の流通・販売",
    description:
      "食品の流通・販売を手がける企業です。安全・安心な食品の提供を通じて、グループの食に関する事業を支えています。",
  },
  {
    id: 7,
    name: "中央農業グリーン株式会社",
    url: "#",
    tagline: "農業法人",
    description:
      "農業生産と農産物の流通を手がける農業法人です。地域農業の発展に貢献し、持続可能な農業の実現を目指しています。",
  },
  {
    id: 8,
    name: "国際ビジネス協同組合",
    url: "http://www.kokubi.com/",
    tagline: "がんばる企業の応援団",
    description:
      "企業の国際展開を支援する協同組合です。海外ビジネスにおける様々な課題解決をサポートし、企業のグローバル化を後押しします。",
  },
  {
    id: 9,
    name: "NPO法人日本オーガニック認証協会",
    url: "https://www.joca-gunma.com/",
    tagline: "有機農産物認証機関",
    description:
      "有機農産物の認証機関として、安心・安全な食の普及に貢献するNPO法人です。有機農業の推進と消費者への信頼提供を担っています。",
  },
];

export const relatedOrganizations = [
  {
    id: 1,
    name: "CHUO Global Village -英語村-",
    url: "https://www.cgv.jp/",
  },
  {
    id: 2,
    name: "資格の学校TAC群馬校",
    url: "https://www.tac-school.co.jp/tacmap/maebasi.html",
  },
  {
    id: 3,
    name: "中央外語学院",
    url: "http://www.chuo-gaigo.com/",
  },
  {
    id: 4,
    name: "DXデザイン研究所",
    url: "http://dxd-lab.com/",
  },
  {
    id: 5,
    name: "アルバイト紹介センターぐんま",
    url: "http://asc-gunma.com/",
  },
  {
    id: 6,
    name: "留学生の皆さまへ「ゆめみらい」",
    url: "https://yumemiraijapan.jp/",
  },
];